import React from 'react'
import { useSelector } from 'react-redux'
import Route from './Route'
import RouteContext from './RouteContext'
import Loading from 'components/system/Loading'

import routerSelectors from '@nocode-works/template/store/selectors/router'

import Layout from 'pages/Layout'
import Login from 'pages/user/Login'
import NotFound from 'pages/NotFound'
import Help from 'pages/Help'

import WebsiteList from 'pages/website/List'
import WebsiteSettings from 'pages/website/Settings'
import TemplateList from 'pages/template/List'
import TemplateView from 'pages/template/View'
import GoogleScopeWarning from 'pages/user/GoogleScopeWarning'
import AccountSettings from 'pages/user/AccountSettings'
import Payments from 'pages/user/Payments'

import AppsumoActivate from 'pages/appsumo/Activate'
import AppsumoWelcome from 'pages/appsumo/Welcome'

const Router = ({

}) => {
  const route = useSelector(routerSelectors.route)

  if(!route) {
    return (
      <Loading />
    )
  }

  return (
    <RouteContext.Provider value={ route.name }>
      <Layout>
        <Route segment="notfound" exact>
          <NotFound />
        </Route>
        <Route segment="help" exact>
          <Help />
        </Route>
        <Route segment="login" exact>
          <Login />
        </Route>
        <Route segment="appsumo.activate" exact>
          <AppsumoActivate />
        </Route>
        <Route segment="appsumo.welcome" exact>
          <AppsumoWelcome />
        </Route>
        <Route segment="scope" exact>
          <GoogleScopeWarning />
        </Route>
        <Route segment="website.list" exact>
          <WebsiteList />
        </Route>
        <Route segment="website.edit" exact>
          <WebsiteSettings />
        </Route>
        <Route segment="template.list" exact>
          <TemplateList />
        </Route>
        <Route segment="template.view" exact>
          <TemplateView />
        </Route>
        <Route segment="account.settings" exact>
          <AccountSettings />
        </Route>
        <Route segment="account.payments" exact>
          <Payments />
        </Route>
      </Layout>
    </RouteContext.Provider>
  )
}

export default Router